var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon1BlogArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 17.7a1 1 0 0 0 1.41.01l5.1-5a1 1 0 0 0 0-1.42l-5.1-5a1 1 0 1 0-1.4 1.42L18.55 11H3a1 1 0 0 0 0 2h15.55l-3.34 3.29a1 1 0 0 0-.01 1.41z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxwYXRoIGQ9Ik0xNS4yIDE3LjdhMSAxIDAgMCAwIDEuNDEuMDFsNS4xLTVhMSAxIDAgMCAwIDAtMS40MmwtNS4xLTVhMSAxIDAgMSAwLTEuNCAxLjQyTDE4LjU1IDExSDNhMSAxIDAgMCAwIDAgMmgxNS41NWwtMy4zNCAzLjI5YTEgMSAwIDAgMC0uMDEgMS40MXoiLz4NCjwvc3ZnPg0K";
export { SvgIcon1BlogArrowRight as ReactComponent };